import React, { useEffect, useState, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-datepicker";
import locale from "date-fns/locale/en-GB";
import "react-datepicker/dist/react-datepicker.css";
import { momentFormate } from "../../helpers/generalHelper";
import moment from "moment";
import { postRequest, postRequestReturnAll } from "../../helpers/apiHelper";

const ScheduleModalAppointment = ({
  appointmentRecordForModal,
  action,
  visible,
  onClose,
  setLoadingModalVisible,
  setConfirmationModalVisible,
  returnAndLoadSchedule,
}) => {
  // Options for appointment type (not used as a dropdown here, since fields are read-only)
  const appointmentTypeOptions = [
    { value: "Personal leave", label: "Personal leave" },
    { value: "Holiday", label: "Holiday" },
    { value: "Unavailable", label: "Unavailable" },
  ];

  // Local states for dates and form values
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const submitbtn = useRef(null);

  // These states are used to load inspector data if needed
  const [userIDOptions, setUserIDOptions] = useState([{ value: "", label: "Select" }]);
  const [inspectorObjArray, setInspectorObjArray] = useState([]);

  // Form state (replaces Formik's initialValues)
  const [formValues, setFormValues] = useState({
    appointmentID: "",
    userID: "",
    appointmentType: "Personal leave",
    appointmentStartDate: momentFormate(startDate),
    appointmentEndDate: momentFormate(startDate),
    appointmentStartTime: "00:00",
    appointmentEndTime: "23:59",
  });

  // Fetch inspector data once when the component mounts
  useEffect(() => {
    const getInspectorUserObjArray = async () => {
      const inspectorArray = await postRequest("/getInspectorUserObjArray");
      setInspectorObjArray(inspectorArray);
      let tempInspectorObjArray = [];
      inspectorArray.forEach((inspectorObj) => {
        tempInspectorObjArray.push({
          value: inspectorObj.uid,
          label: inspectorObj.displayName,
        });
      });
      setUserIDOptions(tempInspectorObjArray);
    };
    getInspectorUserObjArray();
  }, []);

  // Update the form values if an appointment record is passed in (edit mode)
  useEffect(() => {
    if (appointmentRecordForModal && Object.keys(appointmentRecordForModal).length !== 0) {
      const sd = new Date(
        appointmentRecordForModal.appointmentStartDate.split("-").reverse().join("-")
      );
      const ed = new Date(
        appointmentRecordForModal.appointmentEndDate.split("-").reverse().join("-")
      );
      setStartDate(sd);
      setEndDate(ed);
      setFormValues({
        appointmentID: appointmentRecordForModal.appointmentID,
        userID: appointmentRecordForModal.userID,
        appointmentType: appointmentRecordForModal.appointmentType,
        appointmentStartDate: momentFormate(sd),
        appointmentEndDate: momentFormate(ed),
        appointmentStartTime: appointmentRecordForModal.appointmentStartTime,
        appointmentEndTime: appointmentRecordForModal.appointmentEndTime,
      });
    } else {
      // New appointment defaults
      setFormValues({
        appointmentID: "",
        userID: "",
        appointmentType: "Personal leave",
        appointmentStartDate: momentFormate(startDate),
        appointmentEndDate: momentFormate(startDate),
        appointmentStartTime: "00:00",
        appointmentEndTime: "23:59",
      });
    }
  }, [appointmentRecordForModal, startDate]);

  // Helper to update form field values
  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  // Submit function (replaces Formik's onSubmit)
  const submitForm = async (values) => {
    setLoadingModalVisible(true);
    console.log("Form values: ", values);
    let response;
    if (appointmentRecordForModal && Object.keys(appointmentRecordForModal).length !== 0) {
      response = await postRequestReturnAll("/updatePrivateAppointment", values);
    } else {
      response = await postRequestReturnAll("/createPrivateAppointment", values);
    }
    setLoadingModalVisible(false);
    if (
      response.status === 200 ||
      response.status === 201 ||
      response.status === 202
    ) {
      setConfirmationModalVisible(true);
      setTimeout(() => {
        setConfirmationModalVisible(false);
        returnAndLoadSchedule();
      }, 2000);
    } else {
      console.log(
        "An error has occurred when submitting an appointment to the server"
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    submitForm(formValues);
  };

  // The appointment form (read-only)
  const AppointmentForm = () => {
    return (
      <form name="appointment" onSubmit={handleSubmit}>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label className="form-label" htmlFor="appointmentID">
                Appointment ID<span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                disabled
                type="text"
                id="appointmentID"
                name="appointmentID"
                value={formValues.appointmentID}
                onChange={handleFieldChange}
              />
            </div>
          </div>
          <div className="col">
            {/* Empty or additional fields can be placed here */}
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label className="form-label" htmlFor="userID">
                User ID<span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                disabled
                type="text"
                name="userID"
                value={formValues.userID}
                onChange={handleFieldChange}
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label className="form-label" htmlFor="appointmentType">
                Appointment type<span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                disabled
                type="text"
                name="appointmentType"
                value={formValues.appointmentType}
                onChange={handleFieldChange}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label className="form-label" htmlFor="appointmentStartDate">
                Appointment start date<span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                disabled
                type="text"
                name="appointmentStartDate"
                value={formValues.appointmentStartDate}
                onChange={handleFieldChange}
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label className="form-label" htmlFor="appointmentEndDate">
                Appointment end date<span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                disabled
                type="text"
                name="appointmentEndDate"
                value={formValues.appointmentEndDate}
                onChange={handleFieldChange}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label className="form-label" htmlFor="appointmentStartTime">
                Start Time<span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                disabled
                type="text"
                name="appointmentStartTime"
                value={formValues.appointmentStartTime}
                onChange={handleFieldChange}
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label className="form-label" htmlFor="appointmentEndTime">
                End Time<span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                disabled
                type="text"
                name="appointmentEndTime"
                value={formValues.appointmentEndTime}
                onChange={handleFieldChange}
              />
            </div>
          </div>
          {/* Hidden submit button for programmatic submission */}
          <button className="d-none" type="submit" ref={submitbtn}>
            submit
          </button>
        </div>
      </form>
    );
  };

  return (
    <Modal
      show={visible}
      onHide={onClose}
      size="xl"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>Scheduler - Appointment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AppointmentForm />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ScheduleModalAppointment;
